// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collections-wrapper {
  box-sizing: border-box;
  display: flex;
  margin-top: -16px;
}

.collection-wrapper {
  width: 100%;
  height: auto;
  flex: 1;
  margin-left: 20px;
  margin-right: 30px;
}

.image-upload-wrapper {
  width: 424px;
  height: 60px;
  border: 3px dashed lightgray;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-upload-label {
  width: 100%;
  height: 100%;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.filter-mapping-wrapper {
  display: flex;
  margin-bottom: 16px;
  justify-content: space-between;
}

.mapping-method-wrapper {
  width: 424px;
  height: 80px;
  display: flex;
  padding: 0px 12px;
  align-items: center;
  justify-content: space-between;
}

.method-active {
  background-color: rgb(159, 32, 137);
}

.method-inactive {
  border: 3px dashed lightgray;
}

.mapping-text-active {
  float: left;
  color: white;
}

.mapping-text-inactive {
  float: left;
  color: lightgray;
}

.icon-active {
  color: white;
}

.icon-inactive {
  color: lightgray;
}

.submit-button {
  float: right;
  width: fit-content;
  height: 40px;
  background-color: rgb(159, 32, 137);
  margin-left: 20px;
  border-radius: 4px;
  outline: none;
  border: 1px solid rgb(159, 32, 137);
}

.cancel-button {
  float: right;
  width: fit-content;
  height: 40px;
  border: 1px solid rgb(159, 32, 137);
  background-color: white;
  border-radius: 4px;
  outline: none;
}

.collection-tags-wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 280px;
  border: 1px solid lightgray;
  border-top: none;
  margin-top: -12px;
  margin-bottom: 28px;
  padding: 4px;
  overflow-y: scroll;
}

.collection-tags-pallet {
  box-sizing: border-box;
  height: 40px;
  width: fit-content;
  background-color: lightgray;
  display: flex;
  align-items: center;
  padding: 4px;
  margin: 6px;
  border-radius: 4px;
}

.border {
  background-color: white;
  border: 1px solid rgb(159, 32, 137) !important;
  border-radius: 4px 4px 0 0;
}

.collection-tags-text {
  flex: 1;
  align-self: center;
  margin-right: 12px;
}

.collection-tags-button {
  background: none;
  outline: none;
  border: none;
}

.added-tags-wrapper {
  width: 100%;
  height: 210px;
  display: flex;
  flex-wrap: wrap;
}

.added-tags-title {
  font-weight: bold;
}

.filter-groups-wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 96px;
  border: 1px solid lightgray;
  margin: 4px 0px 26px 0px;
  padding: 6px;
  display: flex;
  font-weight: bold;
}

.group-wrapper {
  margin-right: 12px;
  display: flex;
  flex-direction: column;
  flex: 2;
}

.added-filter-group-title {
  width: 100%;
  font-weight: bold;
  background-color: rgb(159, 32, 137);
  color: white;
  padding: 6px;
}

.hvf-wrapper {
  display: flex;
  flex-direction: column;
  flex: 3;
  overflow-x: scroll;
}

.hvf-thumbnail-wrapper {
  display: flex;
  margin-top: 6px;
  align-items: center;
}

.hvf-thumbnail {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 2px solid green;
  background-color: lightgreen;
  margin-right: 10px;
}

.remove-filter {
  align-self: center;
  margin-right: 6px;
  outline: none;
  border: none;
  background-color: white;
}

.fa-trash {
  color: rgb(159, 32, 137);
}

.empty-column {
  width: 300px;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./client/components/dashboard/collection/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mCAAmC;EACnC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".collections-wrapper {\n  box-sizing: border-box;\n  display: flex;\n  margin-top: -16px;\n}\n\n.collection-wrapper {\n  width: 100%;\n  height: auto;\n  flex: 1;\n  margin-left: 20px;\n  margin-right: 30px;\n}\n\n.image-upload-wrapper {\n  width: 424px;\n  height: 60px;\n  border: 3px dashed lightgray;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-upload-label {\n  width: 100%;\n  height: 100%;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.filter-mapping-wrapper {\n  display: flex;\n  margin-bottom: 16px;\n  justify-content: space-between;\n}\n\n.mapping-method-wrapper {\n  width: 424px;\n  height: 80px;\n  display: flex;\n  padding: 0px 12px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.method-active {\n  background-color: rgb(159, 32, 137);\n}\n\n.method-inactive {\n  border: 3px dashed lightgray;\n}\n\n.mapping-text-active {\n  float: left;\n  color: white;\n}\n\n.mapping-text-inactive {\n  float: left;\n  color: lightgray;\n}\n\n.icon-active {\n  color: white;\n}\n\n.icon-inactive {\n  color: lightgray;\n}\n\n.submit-button {\n  float: right;\n  width: fit-content;\n  height: 40px;\n  background-color: rgb(159, 32, 137);\n  margin-left: 20px;\n  border-radius: 4px;\n  outline: none;\n  border: 1px solid rgb(159, 32, 137);\n}\n\n.cancel-button {\n  float: right;\n  width: fit-content;\n  height: 40px;\n  border: 1px solid rgb(159, 32, 137);\n  background-color: white;\n  border-radius: 4px;\n  outline: none;\n}\n\n.collection-tags-wrapper {\n  box-sizing: border-box;\n  width: 100%;\n  height: 280px;\n  border: 1px solid lightgray;\n  border-top: none;\n  margin-top: -12px;\n  margin-bottom: 28px;\n  padding: 4px;\n  overflow-y: scroll;\n}\n\n.collection-tags-pallet {\n  box-sizing: border-box;\n  height: 40px;\n  width: fit-content;\n  background-color: lightgray;\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  margin: 6px;\n  border-radius: 4px;\n}\n\n.border {\n  background-color: white;\n  border: 1px solid rgb(159, 32, 137) !important;\n  border-radius: 4px 4px 0 0;\n}\n\n.collection-tags-text {\n  flex: 1;\n  align-self: center;\n  margin-right: 12px;\n}\n\n.collection-tags-button {\n  background: none;\n  outline: none;\n  border: none;\n}\n\n.added-tags-wrapper {\n  width: 100%;\n  height: 210px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.added-tags-title {\n  font-weight: bold;\n}\n\n.filter-groups-wrapper {\n  box-sizing: border-box;\n  width: 100%;\n  height: 96px;\n  border: 1px solid lightgray;\n  margin: 4px 0px 26px 0px;\n  padding: 6px;\n  display: flex;\n  font-weight: bold;\n}\n\n.group-wrapper {\n  margin-right: 12px;\n  display: flex;\n  flex-direction: column;\n  flex: 2;\n}\n\n.added-filter-group-title {\n  width: 100%;\n  font-weight: bold;\n  background-color: rgb(159, 32, 137);\n  color: white;\n  padding: 6px;\n}\n\n.hvf-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 3;\n  overflow-x: scroll;\n}\n\n.hvf-thumbnail-wrapper {\n  display: flex;\n  margin-top: 6px;\n  align-items: center;\n}\n\n.hvf-thumbnail {\n  height: 50px;\n  width: 50px;\n  border-radius: 50%;\n  border: 2px solid green;\n  background-color: lightgreen;\n  margin-right: 10px;\n}\n\n.remove-filter {\n  align-self: center;\n  margin-right: 6px;\n  outline: none;\n  border: none;\n  background-color: white;\n}\n\n.fa-trash {\n  color: rgb(159, 32, 137);\n}\n\n.empty-column {\n  width: 300px;\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
